import type React from 'react';

import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';

import StandardButton from 'components/buttons/StandardButton';
import { type IdNameParticipantsInterface } from 'components/overlays/doubles/types';
import { useStyles } from 'components/panels/doubles/styles';

interface UnpairedPlayersListItemProps {
  isLastItem?: boolean;
  participant: IdNameParticipantsInterface;
  onPairParticipants: (participant: IdNameParticipantsInterface) => void;
}

const UnpairedPlayersListItem: React.FC<React.PropsWithChildren<UnpairedPlayersListItemProps>> = ({
  isLastItem,
  participant,
  onPairParticipants,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const handleOnClick = () => {
    onPairParticipants(participant);
  };

  return (
    <ListItem
      key={participant.participantId}
      className={!isLastItem ? classes.unpairedListItem : classes.unpairedListItemNoBorder}
    >
      <ListItemText primary={participant?.name} />
      <ListItemSecondaryAction className={classes.unpairedListItemSecondaryAction}>
        <StandardButton onClick={handleOnClick}>{t('pair')}</StandardButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default UnpairedPlayersListItem;
